<a
  routerLink="/checkout"
  class="checkout-link position-relative d-inline-flex align-items-center justify-content-center"
  aria-label="Abrir carrito de reservas"
  title="Carrito de reservas"
>
  <i class="inm-icon-checkout icon-checkout" aria-hidden="true"></i>
</a>
